import React, {useState} from "react";

import { Modal } from "react-bootstrap";
import FormValidate from "../Form/validateUser";
import { useParams } from "react-router";
import {i18n} from "../../translate/i18n";
import {changeStatus} from "../../pages/Collect/actions";
import {getGoalId} from "../../services/Goals.service";
import {getIndicator} from "../../services/Indicators.service";
import {useQuery} from "react-query";
import {toast} from "react-toastify";
import {Tooltip} from "../Tooltip";
import {useUser} from "../../store/providers/app";
import {UsersIndicator} from "../UsersIndicator";
import {rulesAdvanceStatus} from "../../utils/rulesContent";

export default function Steps({ idDb, onlyIcon = false, statusIndicator = '', param= "indicator", showUsers = true }) {

    const { id } = useParams()

    const idSearch = id ?? idDb

    const { user } = useUser()

    const [show, setShow] = useState(false)
    const [status, setStatus] = useState(statusIndicator)
    const [language, setLanguage] = useState('')
    const [title, setTitle] = useState('')

    const [authStatus, setAuthStatus] = useState(false)


    const handleClose = () => {
        setShow(!show)
    }

    const {isLoading} = useQuery(["step", idSearch, show],
        () => {
            return show && param === 'indicator' ? getIndicator(idSearch) :  show && param === 'goal' && getGoalId(idSearch)
        }, {
            onSuccess: (response) => {
                if  (response) {
                    setTitle(param === 'indicator' ? response.titulo : response.titulo_meta);
                    setStatus(response.status)
                    setLanguage(response.language)
                }

                if(param === 'goal') {
                    setAuthStatus(true)
                }
            },
            onError: () => {
                toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false
        }
    )

    const updateAuthStatus = (status) => {
        setAuthStatus(status)
    }


    return (
        <>
            <div className="d-flex justify-content-end gap-1">
                {!onlyIcon  &&
                    <span className={`rounded-1 text-sm px-3 d-flex align-items-center ${ changeStatus(status).bg }`}>
                                    { status ?  changeStatus(status).label : 'Aguarde...'}
                    </span>
                }

                { param === 'indicator' && showUsers &&
                    <UsersIndicator
                        indicatorId={idDb}
                        status={statusIndicator}
                        updateAuthStatus={updateAuthStatus}
                    />
                }

                { param === 'indicator' && rulesAdvanceStatus.map(item => (
                    item.allowedProfiles.includes(user.profile) && item.status === status && (
                        <Tooltip label="Mudar estágio" key={item.id}>
                            <button
                                type="button"
                                className="btn btn-sm btn-secondary"
                                onClick={() => setShow(true)} disabled={!authStatus && user.profile !== 1}
                            >
                                <i className="bi bi-play"/>
                            </button>
                        </Tooltip>
                    )
                ))}
                { param === 'goal' && user.profile === 1 &&
                    <Tooltip label="Mudar estágio">
                        <button
                            type="button"
                            className="btn btn-sm btn-secondary"
                            onClick={() => setShow(true)}
                        >
                            <i className="bi bi-play"/>
                        </button>
                    </Tooltip>
                }
            </div>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body>
                    <FormValidate
                        title={title}
                        status={status}
                        handleClose={handleClose}
                        idDb={idSearch}
                        show={show}
                        param={param}
                        language={language}
                    />
                </Modal.Body>
            </Modal>
        </>
    )
}


